import React, {Fragment} from "react";
import AddUser from "../../../components/Modal/AddUser";
import DeleteModal from "../../../components/Modal/DeleteModal";
import ListView from "../../../components/ContentDisplay/ListView";
import {UserCard} from "./userCard";
import {ACTIONS_LIST, LIST_HEADERS, PERMS_FOR_ACTIONS} from "./userTable.constants";
import {useUserSearchOptions} from "./useUserSearchOptions";
import {useUserTableAction} from "./useUserTableAction";
import {useUserTableData} from "./useUserTableData";

const UsersTable = () => {
  const {searchOptions} = useUserSearchOptions();
  const {fetchAfterDelete, handleSearch, paginationConfig, totalCount, usersList} =
    useUserTableData();
  const {
    deleteModalStatus,
    deleteUser,
    editModalStatus,
    formType,
    handleActionSelection,
    setDeleteModalStatus,
    setEditModalStatus,
  } = useUserTableAction(fetchAfterDelete);

  return (
    <Fragment>
      <AddUser
        open={editModalStatus}
        onClose={() => setEditModalStatus(false)}
        formType={formType}
      />
      <DeleteModal
        header={"Delete user"}
        modalBody={"Are you sure you want to delete this user ?"}
        onClose={() => setDeleteModalStatus(false)}
        onDelete={deleteUser}
        open={deleteModalStatus}
      />
      <ListView
        cardContent={UserCard}
        listItems={usersList}
        listHeaders={LIST_HEADERS}
        withActions
        actionsList={ACTIONS_LIST}
        permsForActions={PERMS_FOR_ACTIONS}
        onSelectAction={handleActionSelection}
        totalCount={totalCount}
        withPagination={paginationConfig}
        withSearchQuery={true}
        searchPlaceHolder={"Filter Users"}
        searchOptions={searchOptions}
        handleSearch={handleSearch}
      />
    </Fragment>
  );
};

export default UsersTable;
